import React from "react";

interface LensIconProps {
  className?: string;
  size?: number;
}

const LensIcon: React.FC<LensIconProps> = ({ className = "", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Outer lens ring */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Inner lens ring */}
      <circle
        cx="12"
        cy="12"
        r="6"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Center aperture */}
      <circle
        cx="12"
        cy="12"
        r="3"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Lens reflection highlight */}
      <path
        d="M8 8l3 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.6"
      />
      {/* Small aperture blades */}
      <g opacity="0.4">
        <line x1="12" y1="9" x2="12" y2="15" stroke="currentColor" strokeWidth="0.5"/>
        <line x1="15" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="0.5"/>
        <line x1="14.12" y1="9.88" x2="9.88" y2="14.12" stroke="currentColor" strokeWidth="0.5"/>
        <line x1="14.12" y1="14.12" x2="9.88" y2="9.88" stroke="currentColor" strokeWidth="0.5"/>
      </g>
    </svg>
  );
};

export default LensIcon;
